import React from 'react';
import Card from 'react-bootstrap/Card';
import {
  FormField,
  HelpBlock,
  InputText,
  Label,
  Row,
} from '../../common/form';
import Header from './header';
import Pane from './pane';
import FundContext from './context';
import { isValidPerformanceValue, PERFORMANCE_VALUE_ERROR } from './performance-value';

export default function FundPerformance() {
  const { state, dispatch } = React.useContext(FundContext);
  const [attributes, setAttributes] = React.useState(state.fund.performance);

  const event = 'performance';

  const handleChange = (e, name) => {
    const newData = attributes.map(attribute => (
      { ...attribute, ...(attribute.name === name ? { value: e.target.value } : {}) }));
    setAttributes(newData);
    dispatch({ type: 'setPerformance', payload: newData });
  };

  return (
    <Card>
      <Card.Header>
        <Header eventKey={event}>Fund Performance</Header>
      </Card.Header>
      <Pane eventKey={event}>
        <Card.Body>
          {attributes.map(attribute => {
            const isInvalid = !isValidPerformanceValue(attribute.value);
            const inputId = `fund-performance-attribute-${attribute.name}`;
            return (
              <Row key={`fund-performance-${attribute.name}`}>
                <Label htmlFor={inputId}>{attribute.label}</Label>
                <FormField>
                  <InputText
                    id={inputId}
                    type="text"
                    name={`fundPerformanceAttribute${attribute.name}`}
                    value={attribute.value}
                    onChange={e => handleChange(e, attribute.name)}
                  />
                  {isInvalid && <HelpBlock>{PERFORMANCE_VALUE_ERROR}</HelpBlock>}
                </FormField>
              </Row>
            );
          })}
        </Card.Body>
      </Pane>
    </Card>
  );
}
